import { createContext, useContext } from 'react'

const SettingsModalEmbedContext = createContext(false)

export const SettingsModalEmbedProvider = SettingsModalEmbedContext.Provider

/** True when user groups (or other admin surfaces) render inside the settings modal overlay. */
export const useSettingsModalEmbed = () => {
  const context = useContext(SettingsModalEmbedContext)
  if (typeof context === 'boolean') {
    return context
  }
  return Boolean(context?.embedded)
}

/**
 * Router objects for embedded settings content. Memory-routed pages render under their own
 * Router, so modal-safe navigation needs the outer browser router to update `?settings=`.
 */
export const useSettingsModalEmbedNavigation = () => {
  const context = useContext(SettingsModalEmbedContext)
  if (typeof context === 'boolean') {
    return {
      embedded: context,
      browserHistory: null,
      browserLocation: null,
      getSettingsModalTarget: null,
    }
  }
  return {
    embedded: Boolean(context?.embedded),
    browserHistory: context?.browserHistory ?? null,
    browserLocation: context?.browserLocation ?? null,
    getSettingsModalTarget: context?.getSettingsModalTarget ?? null,
  }
}
